import { BaseLearnLanguage } from 'src/types/learnLanguage';

export const learnLanguages: { [key: string]: BaseLearnLanguage } = {
  ENG: {
    alpha2: 'en',
    title: 'English',
    flag: 'FlagEng'
  },
  SPA: {
    alpha2: 'es',
    title: 'Spanish',
    flag: 'FlagSpa'
  },
  FRA: {
    alpha2: 'fr',
    title: 'French',
    flag: 'FlagFra'
  },
  ITA: {
    alpha2: 'it',
    title: 'Italian',
    flag: 'FlagIta'
  },
  DEU: {
    alpha2: 'de',
    title: 'German',
    flag: 'FlagDeu'
  },
  POR: {
    alpha2: 'pt',
    title: 'Portuguese',
    flag: 'FlagPor'
  },
  SWE: {
    alpha2: 'sv',
    title: 'Swedish',
    flag: 'FlagSwe'
  },
  TUR: {
    alpha2: 'tr',
    title: 'Turkish',
    flag: 'FlagTur'
  },
  NLD: {
    alpha2: 'nl',
    title: 'Dutch',
    flag: 'FlagNld'
  },
  POL: {
    alpha2: 'pl',
    title: 'Polish',
    flag: 'FlagPol'
  },
  DAN: {
    alpha2: 'dk',
    title: 'Danish',
    flag: 'FlagDan'
  },
  NOR: {
    alpha2: 'no',
    title: 'Norwegian',
    flag: 'FlagNor'
  },
  IND: {
    alpha2: 'id',
    title: 'Indonesian',
    flag: 'FlagInd'
  },
  RUS: {
    alpha2: 'ru',
    title: 'Russian',
    flag: 'FlagRus'
  },
  QMS: {
    alpha2: 'es',
    title: 'Mexican',
    flag: 'FlagQms'
  }
};
